<section class="page-shell">
  <header class="page-hero dbw-card dbw-card--xl">
    <div>
      <p class="eyebrow">Atlas</p>
      <h3>{{ overview()?.displayName || 'Consultant #' + consultantId() }}</h3>
    </div>

    <div class="hero-actions">
      <oui-button
        color="secondary"
        type="outlined"
        (click)="openViewerSearch()">
        Retour à la recherche consultant
      </oui-button>
      <oui-button
        color="secondary"
        type="outlined"
        iconSuffix="sync"
        (click)="reload()"
        [disabled]="loading()">
        Recharger
      </oui-button>
    </div>
  </header>

  @if (loading()) {
    <dbw-state-card appearance="loading">
      <p>Chargement de l'inspection consultant en cours.</p>
    </dbw-state-card>
  }

  @if (error() && !loading()) {
    <dbw-state-card
      appearance="error"
      title="Chargement impossible">
      <p>{{ error() }}</p>
    </dbw-state-card>
  }

  @if (overview(); as vm) {
    <dbw-summary-grid [items]="summaryGridItems()"></dbw-summary-grid>

    <dbw-state-card
      appearance="info"
      title="Synthèse consultant">
      <div class="diagnostic-summary">
        <div class="tag-cluster diagnostic-tags">
          <oui-tag
            type="status"
            size="big"
            [status]="vm.persons.length > 0 ? 'completed' : 'error'">
            {{ vm.persons.length > 0 ? 'Personne liée' : 'Sans personne liée' }}
          </oui-tag>
          <oui-tag
            type="status"
            size="big"
            [status]="activeLegalStatusCount() > 0 ? 'completed' : 'pending'">
            {{ activeLegalStatusCount() }} statut(s) actif(s)
          </oui-tag>
          <oui-tag
            type="status"
            size="big"
            [status]="activeHabilitationCount() > 0 ? 'completed' : 'pending'">
            {{ activeHabilitationCount() }} habilitation(s) ouverte(s)
          </oui-tag>
        </div>
      </div>
    </dbw-state-card>

    <section class="content-grid">
      <article class="panel dbw-card dbw-card--xl">
        <div class="panel-heading">
          <div>
            <h4>Fiche consultant</h4>
            <p>#{{ vm.consultantId }}</p>
          </div>
          <div class="tag-cluster">
            <dbw-consultant-status-tag [statusCode]="vm.statusCode"></dbw-consultant-status-tag>
          </div>
        </div>

        <div class="identity-grid">
          <article class="identity-item dbw-card dbw-card--lg">
            <span class="identity-item__label">Nom affiché</span>
            <strong>{{ vm.displayName }}</strong>
          </article>
          <article class="identity-item dbw-card dbw-card--lg">
            <span class="identity-item__label">Code consultant</span>
            <strong>{{ formatText(vm.consultantCode) }}</strong>
          </article>
          <article class="identity-item dbw-card dbw-card--lg">
            <span class="identity-item__label">ArianeId</span>
            <strong>{{ formatText(vm.arianeId) }}</strong>
          </article>
          <article class="identity-item dbw-card dbw-card--lg">
            <span class="identity-item__label">Raison sociale</span>
            <strong>{{ formatText(vm.raisonSociale) }}</strong>
          </article>
          <article class="identity-item dbw-card dbw-card--lg">
            <span class="identity-item__label">Qualification</span>
            <strong>{{ formatText(vm.qualificationLabel || vm.qualificationCode) }}</strong>
          </article>
          <article class="identity-item dbw-card dbw-card--lg">
            <span class="identity-item__label">Titre</span>
            <strong>{{ formatText(vm.titleLabel || vm.titleCode) }}</strong>
          </article>
          <article class="identity-item dbw-card dbw-card--lg">
            <span class="identity-item__label">Affiliation</span>
            <strong>{{ formatDate(vm.affiliationDate) }}</strong>
          </article>
          <article class="identity-item dbw-card dbw-card--lg">
            <span class="identity-item__label">Entrée / départ</span>
            <strong> {{ formatDate(vm.entryDate) }} • {{ formatDate(vm.resignationDate || vm.resiliationDate) }} </strong>
          </article>
        </div>
      </article>

      <article class="panel dbw-card dbw-card--xl">
        <div class="panel-heading">
          <div>
            <h4>Bouquet de service</h4>
            <p>Abonnement B2S du consultant.</p>
          </div>
          @if (bouquetServiceSubscription(); as subscription) {
            <div class="row-actions">
              @if (subscription.subscriptionStatus === 'subscribed' || subscription.subscriptionStatus === 'terminationScheduled') {
                <oui-button
                  type="icon"
                  ouiTooltip="Résilier l'abonnement"
                  color="error"
                  (click)="terminateSubscription(subscription)"
                  [disabled]="!canManageSubscription() || actionInProgressConsultantId() !== undefined">
                  <oui-icon>block</oui-icon>
                </oui-button>
              }

              @if (subscription.subscriptionStatus === 'notSubscribed' || subscription.subscriptionStatus === 'terminationScheduled') {
                <oui-button
                  type="icon"
                  [ouiTooltip]="getActivationTooltip(subscription)"
                  color="valid"
                  (click)="activateSubscription(subscription)"
                  [disabled]="!canManageSubscription() || actionInProgressConsultantId() !== undefined">
                  <oui-icon>check_circle</oui-icon>
                </oui-button>
              }
            </div>
          }
        </div>

        @if (bouquetServiceLoading()) {
          <div class="empty-inline">Chargement de l'abonnement Bouquet de service.</div>
        } @else if (bouquetServiceError()) {
          <div class="empty-inline empty-inline--error">{{ bouquetServiceError() }}</div>
        } @else {
          @if (bouquetServiceSubscription(); as subscription) {
            <div class="detail-grid detail-grid--compact">
              <article class="detail-item dbw-card dbw-card--md">
                <span class="detail-item__label">Statut abonnement</span>
                <dbw-consultant-subscription-tag
                  [isSubscribed]="subscription.isSubscribed"
                  [subscriptionStatus]="subscription.subscriptionStatus"></dbw-consultant-subscription-tag>
              </article>
              <article class="detail-item dbw-card dbw-card--md">
                <span class="detail-item__label">Date de fin</span>
                <strong>{{ formatDate(subscription.subscriptionEndDate) }}</strong>
              </article>
              <article class="detail-item dbw-card dbw-card--md">
                <span class="detail-item__label">Acceptation CGV</span>
                <strong>{{ formatBoolean(subscription.hasAcceptedTerms) }}</strong>
              </article>
              <article class="detail-item dbw-card dbw-card--md">
                <span class="detail-item__label">Expiration accès</span>
                <strong>{{ formatDate(subscription.accessExpirationDate) }}</strong>
              </article>
              <article class="detail-item dbw-card dbw-card--md">
                <span class="detail-item__label">Fin période gratuite</span>
                <strong>{{ formatDate(subscription.freePeriodEndDate) }}</strong>
              </article>
              <article class="detail-item dbw-card dbw-card--md">
                <span class="detail-item__label">Dernier paiement</span>
                <strong>{{ formatDate(subscription.lastPaymentDate) }}</strong>
              </article>
            </div>
          } @else {
            <div class="empty-inline">Aucune information B2S disponible pour ce consultant.</div>
          }
        }
      </article>

      @if (contacts(); as contactData) {
        <article class="panel dbw-card dbw-card--xl">
          <div class="panel-heading">
            <div>
              <h4>Contacts et personnes</h4>
              <p>Coordonnées directes du consultant et personnes physiques liées.</p>
            </div>
          </div>

          <div class="card-list">
            <article class="sub-card dbw-card dbw-card--lg">
              <div class="subheading"><h5>Personnes physiques</h5></div>
              @if (contactData.persons.length === 0) {
                <div class="empty-inline">Aucune personne physique liée.</div>
              } @else {
                <div class="section-stack">
                  @for (person of contactData.persons; track person.personId) {
                    <div class="mini-block">
                      <strong>{{ formatIdentity(person.lastName, person.firstName, 'Personne #' + person.personId) }}</strong>
                      <span class="muted">
                        #{{ person.personId }} • Code {{ formatText(person.personCode) }} • Né(e) le
                        {{ formatDate(person.birthDate) }}
                      </span>
                    </div>
                  }
                </div>
              }
            </article>

            <article class="sub-card dbw-card dbw-card--lg">
              <div class="subheading"><h5>Emails directs</h5></div>
              @if (contactData.directEmails.length === 0) {
                <div class="empty-inline">Aucun email direct.</div>
              } @else {
                <div class="section-stack">
                  @for (email of contactData.directEmails; track email.emailId) {
                    <div class="mini-block">
                      <strong>{{ formatText(email.address) }}</strong>
                      <span class="muted"> {{ formatText(email.emailTypeCode) }} • Note {{ formatText(email.notes) }} </span>
                    </div>
                  }
                </div>
              }
            </article>

            <article class="sub-card dbw-card dbw-card--lg">
              <div class="subheading"><h5>Téléphones directs</h5></div>
              @if (contactData.directPhones.length === 0) {
                <div class="empty-inline">Aucun téléphone direct.</div>
              } @else {
                <div class="section-stack">
                  @for (phone of contactData.directPhones; track phone.phoneId) {
                    <div class="mini-block">
                      <strong>{{ formatPhone(phone) }}</strong>
                      <span class="muted"> {{ formatText(phone.phoneTypeCode) }} • Note {{ formatText(phone.notes) }} </span>
                    </div>
                  }
                </div>
              }
            </article>

            <article class="sub-card dbw-card dbw-card--lg">
              <div class="subheading"><h5>Adresses directes</h5></div>
              @if (contactData.directAddresses.length === 0) {
                <div class="empty-inline">Aucune adresse directe.</div>
              } @else {
                <div class="section-stack">
                  @for (address of contactData.directAddresses; track address.addressId) {
                    <div class="mini-block">
                      <strong>{{ formatAddress(address) }}</strong>
                      <span class="muted"> {{ formatText(address.addressTypeCode) }} • Note {{ formatText(address.notes) }} </span>
                    </div>
                  }
                </div>
              }
            </article>
          </div>
        </article>
      } @else if (contactsLoading()) {
        <dbw-state-card
          appearance="loading"
          title="Contacts et personnes">
          <p>Chargement des contacts consultant en cours.</p>
        </dbw-state-card>
      } @else if (contactsError()) {
        <dbw-state-card
          appearance="error"
          title="Contacts et personnes">
          <p>{{ contactsError() }}</p>
        </dbw-state-card>
      }

      @if (organization(); as organizationData) {
        <article class="panel dbw-card dbw-card--xl">
          <div class="panel-heading">
            <div>
              <h4>Organisation</h4>
              <p>Hiérarchie commerciale et structure réseau du consultant.</p>
            </div>
          </div>

          <div class="card-list">
            <article class="sub-card dbw-card dbw-card--lg">
              <div class="subheading"><h5>Référents</h5></div>
              <div class="section-stack">
                <div class="mini-block">
                  <span class="identity-item__label">Parrain</span>
                  @if (organizationData.sponsor; as sponsor) {
                    <dbw-consultant-card
                      [id]="sponsor.consultantId"
                      [code]="formatText(sponsor.consultantCode)"
                      [name]="formatText(sponsor.consultantName)"
                      [statusCode]="sponsor.statusCode"></dbw-consultant-card>
                  } @else {
                    <strong>-</strong>
                  }
                </div>
                <div class="mini-block">
                  <span class="identity-item__label">Manager</span>
                  @if (organizationData.manager; as manager) {
                    <dbw-consultant-card
                      [id]="manager.consultantId"
                      [code]="formatText(manager.consultantCode)"
                      [name]="formatText(manager.consultantName)"
                      [statusCode]="manager.statusCode"></dbw-consultant-card>
                  } @else {
                    <strong>-</strong>
                  }
                </div>
                <div class="mini-block">
                  <span class="identity-item__label">Tête de réseau</span>
                  @if (organizationData.networkHead; as networkHead) {
                    <dbw-consultant-card
                      [id]="networkHead.consultantId"
                      [code]="formatText(networkHead.consultantCode)"
                      [name]="formatText(networkHead.consultantName)"
                      [statusCode]="networkHead.statusCode"></dbw-consultant-card>
                  } @else {
                    <strong>-</strong>
                  }
                </div>
              </div>
            </article>

            <article class="sub-card dbw-card dbw-card--lg">
              <div class="subheading"><h5>Constellation</h5></div>
              <div class="section-stack">
                @for (
                  relation of [
                    { label: 'Galaxie', value: organizationData.galaxy },
                    { label: 'Manager organisation', value: organizationData.organizationManager },
                    { label: 'Planète', value: organizationData.planet },
                    { label: 'Étoile', value: organizationData.star },
                    { label: 'Constellation', value: organizationData.constellation },
                    { label: 'Galaxie organisation', value: organizationData.organizationGalaxy },
                  ];
                  track relation.label
                ) {
                  <div class="mini-block">
                    <span class="identity-item__label">{{ relation.label }}</span>
                    @if (relation.value; as reference) {
                      <dbw-consultant-card
                        [id]="reference.consultantId"
                        [code]="formatText(reference.consultantCode)"
                        [name]="formatText(reference.consultantName)"
                        [statusCode]="reference.statusCode"></dbw-consultant-card>
                    } @else {
                      <strong>-</strong>
                    }
                  </div>
                }
              </div>
            </article>

            <article class="sub-card dbw-card dbw-card--lg">
              <div class="subheading"><h5>Indicateurs</h5></div>
              <div class="detail-grid detail-grid--compact">
                <article class="detail-item dbw-card dbw-card--md">
                  <span class="detail-item__label">Taux rémunération</span>
                  <strong>{{ formatPercentage(organizationData.remunerationRate) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--md">
                  <span class="detail-item__label">Membres 4 niveaux</span>
                  <strong>{{ formatText(organizationData.fourLevelMemberCount) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--md">
                  <span class="detail-item__label">Membres 8 niveaux</span>
                  <strong>{{ formatText(organizationData.eightLevelMemberCount) }}</strong>
                </article>
              </div>
            </article>
          </div>
        </article>
      } @else if (organizationLoading()) {
        <dbw-state-card
          appearance="loading"
          title="Organisation">
          <p>Chargement de l'organisation consultant en cours.</p>
        </dbw-state-card>
      } @else if (organizationError()) {
        <dbw-state-card
          appearance="error"
          title="Organisation">
          <p>{{ organizationError() }}</p>
        </dbw-state-card>
      }

      @if (compliance(); as complianceData) {
        <article class="panel dbw-card dbw-card--xl">
          <div class="panel-heading">
            <div>
              <h4>Cadre réglementaire</h4>
              <p>Statuts juridiques, contrats, RCP et habilitations du consultant.</p>
            </div>
          </div>

          <div class="card-list">
            <article class="sub-card dbw-card dbw-card--lg">
              <div class="subheading"><h5>Statuts juridiques</h5></div>
              @if (complianceData.legalStatuses.length === 0) {
                <div class="empty-inline">Aucun statut juridique.</div>
              } @else {
                <div class="section-stack">
                  @for (status of complianceData.legalStatuses; track status.legalStatusId) {
                    <div class="mini-block block-divider">
                      <strong>{{ formatText(status.legalStatusLabel || status.legalStatusCode) }}</strong>
                      <span class="muted">
                        {{ formatText(status.tradeName || status.companyName) }} • {{ formatText(status.stateLabel || status.stateCode) }} •
                        {{ status.isActive ? 'Actif' : 'Inactif' }}
                      </span>
                      <span class="muted"> SIRET {{ formatText(status.siret) }} • TVA {{ formatText(status.vatNumber) }} </span>
                      <span class="muted">
                        {{ status.professionalAddress ? formatAddress(status.professionalAddress) : '-' }}
                      </span>
                    </div>
                  }
                </div>
              }
            </article>

            <article class="sub-card dbw-card dbw-card--lg">
              <div class="subheading"><h5>Contrats</h5></div>
              @if (complianceData.contracts.length === 0) {
                <div class="empty-inline">Aucun contrat.</div>
              } @else {
                <div class="section-stack">
                  @for (contract of complianceData.contracts; track contract.contractId) {
                    <div class="mini-block block-divider">
                      <strong>{{ formatText(contract.contractTypeLabel || contract.contractTypeCode) }}</strong>
                      <span class="muted">
                        Contrat #{{ contract.contractId }} • Statut #{{ contract.legalStatusId }} •
                        {{ formatDate(contract.contractDate) }}
                      </span>
                    </div>
                  }
                </div>
              }
            </article>

            <article class="sub-card dbw-card dbw-card--lg">
              <div class="subheading"><h5>RCP</h5></div>
              @if (complianceData.rcps.length === 0) {
                <div class="empty-inline">Aucune RCP.</div>
              } @else {
                <div class="section-stack">
                  @for (rcp of complianceData.rcps; track rcp.rcpId) {
                    <div class="mini-block block-divider">
                      <strong>{{ formatText(rcp.insurerName || rcp.rcpTypeCode) }}</strong>
                      <span class="muted">
                        Type {{ formatText(rcp.rcpTypeCode) }} • Garantie {{ formatText(rcp.guaranteeAmountPerClaim) }} • Début
                        {{ formatDate(rcp.startDate) }}
                      </span>
                      <span class="muted"> Fin {{ formatDate(rcp.endDate) }} • Annulation {{ formatDate(rcp.cancellationDate) }} </span>
                    </div>
                  }
                </div>
              }
            </article>

            <article class="sub-card dbw-card dbw-card--lg">
              <div class="subheading"><h5>Habilitations</h5></div>
              @if (complianceData.habilitations.length === 0) {
                <div class="empty-inline">Aucune habilitation.</div>
              } @else {
                <div class="section-stack">
                  @for (habilitation of complianceData.habilitations; track habilitation.habilitationAssignmentId) {
                    <div class="mini-block block-divider">
                      <strong>{{ formatText(habilitation.habilitationLabel || habilitation.habilitationCode) }}</strong>
                      <span class="muted">
                        Début {{ formatDate(habilitation.startDate) }} • Fin {{ formatDate(habilitation.endDate) }} • Statut
                        {{ formatText(habilitation.status) }}
                      </span>
                      <span class="muted">
                        Association {{ formatText(habilitation.professionalAssociationName) }} • Médiateur
                        {{ formatText(habilitation.mediator) }}
                      </span>
                      @if (habilitation.inscriptions.length > 0) {
                        <div class="field-chip-list">
                          @for (inscription of habilitation.inscriptions; track inscription.inscriptionId) {
                            <span class="field-chip">
                              {{ formatText(inscription.organizationLabel || inscription.organizationCode) }}
                              • {{ formatText(inscription.registrationNumber) }}
                            </span>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </article>
          </div>
        </article>
      } @else if (complianceLoading()) {
        <dbw-state-card
          appearance="loading"
          title="Cadre réglementaire">
          <p>Chargement des informations réglementaires en cours.</p>
        </dbw-state-card>
      } @else if (complianceError()) {
        <dbw-state-card
          appearance="error"
          title="Cadre réglementaire">
          <p>{{ complianceError() }}</p>
        </dbw-state-card>
      }
    </section>
  }
</section>
